// extracted by mini-css-extract-plugin
export default {"loading":"SearchEngines_loading__EsHPI"};